import apiService from './apiService'

const requestDoctorSpecialities = (query) => {
  return apiService.get(URIS.specialities)
}

const requestDoctorList = (query) => {
  let queryParams = {
    q: query?.doctor ?? '',
    specialization: query?.specialities?.join(',') ?? '',
    item_per_page:  10,
    page: query?.page ?? 1,
  }

  return apiService.get(URIS_D('doctorList'), {
    params: queryParams,
  })
}

const requestDoctorInfo = (doctorId) => {
  return apiService.get(URIS_D('doctorDetail', doctorId))
}

const requestCommunities = () => {
  return apiService.get(URIS.communities)
}

const requestEditDoctorProfile = (payload) => {
  return apiService.put(URIS_D('editDoctor', payload.id), payload)
}

const requestAddSpeciality = (payload) => {
  return apiService.post(URIS_D('addSpeciality', payload.doctorId), [
    payload.speciality,
  ])
}

const requestAddExperience = (payload) => {
  return apiService.post(URIS_D('addExperience', payload.id), payload.data)
}

const requestAddEducation = (payload) => {
  return apiService.post(URIS_D('addEducation', payload.id), payload.data)
}

const requestAddCommunities = (payload) => {
  return apiService.post(
    URIS_D('addCommunities', payload.id),
    payload.community,
  )
}

const requestDeleteCommunity = (payload) => {
  return apiService.delete(
    URIS_D('deleteCommunity', payload.id, payload.communityId),
  )
}

const requestDeleteSpeciality = (payload) => {
  return apiService.delete(
    URIS_D('deleteSpeciality', payload.id, payload.specialityId),
    payload.community,
  )
}

const requestDeleteEducation = (payload) => {
  return apiService.delete(
    URIS_D('deleteEducation', payload.id, payload.educationId),
  )
}

const requestDeleteExperience = (payload) => {
  return apiService.delete(
    URIS_D('deleteExperience', payload.id, payload.experienceId),
  )
}

const requestUpdateExperience = (payload) => {
  return apiService.put(
    URIS_D('updateExperience', payload.id),
    payload.userChanges,
  )
}

const requestUpdateEducation = (payload) => {
  return apiService.put(
    URIS_D('updateEducation', payload.id),
    payload.userChanges,
  )
}

const requestGetDoctorsBySpecialitiesOrName = (payload) => {
  let queryParams = {
    q: payload.doctor,
    item_per_page: 50,
    specialization: payload.specialities.join(','),
  }

  return apiService.get(URIS.doctorSearch, {
    params: queryParams,
  })
}

const requestVerifyNmc = (payload) => {
  let status = {status:"NMC_VERIFIED"}
  return apiService.patch(URIS_D('verifyNmc', payload.id), status)
}

export {
  requestDoctorSpecialities,
  requestDoctorList,
  requestDoctorInfo,
  requestCommunities,
  requestEditDoctorProfile,
  requestAddSpeciality,
  requestAddExperience,
  requestAddEducation,
  requestAddCommunities,
  requestGetDoctorsBySpecialitiesOrName,
  requestDeleteSpeciality,
  requestDeleteCommunity,
  requestDeleteExperience,
  requestDeleteEducation,
  requestUpdateEducation,
  requestUpdateExperience,
  requestVerifyNmc,
}

const URIS_D = (url, param1 = '', param2 = '') => {
  return {
    doctorList: `admin/doctors/search`,
    doctorDetail: `doctors/${param1}`,
    editDoctor: `admin/doctors/${param1}`,
    addSpeciality: `admin/doctors/${param1}/specializations`,
    addExperience: `admin/doctors/${param1}/experiences`,
    addEducation: `admin/doctors/${param1}/educations`,
    addCommunities: `admin/doctors/${param1}/communities`,
    deleteCommunity: `admin/doctors/${param1}/communities/${param2}`,
    deleteSpeciality: `admin/doctors/${param1}/specializations/${param2}`,
    deleteEducation: `admin/doctors/${param1}/educations/${param2}`,
    deleteExperience: `admin/doctors/${param1}/experiences/${param2}`,
    updateEducation: `admin/doctors/${param1}/educations`,
    updateExperience: `admin/doctors/${param1}/experiences`,
    verifyNmc: `admin/doctors/${param1}`,
  }[url]
}

const URIS = {
  specialities: '/specialities',
  communities: 'admin/communities',
  doctorSearch: `admin/doctors/search`,
}
